<template>
  <div class="wrap_content">
    <a-config-provider :locale="locale">    
      <!--需要缓存的keep-alive配置 展示内容-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
  </a-config-provider>
  <a-config-provider :locale="locale">
    <!--不需要缓存的keep-alive 配置 展示内容-->
    <router-view v-if="!$route.meta.keepAlive" />
  </a-config-provider>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN"; //中文
export default {
  data() {
    return {
      locale: zhCN,
    };
  },
  created(){
    // console.log(this.$route.meta.keepAlive);
  },
};
</script>

<style scoped lang="less">
</style>
